import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigYoutubeMcpSettings } from "./app-settings-config-youtube";

export interface IConfigYoutubeMcpInputState {
  showModal: boolean;
  editingYoutubeMcpId: string;
}

export interface IConfigYoutubeMcpInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigYoutubeMcpInput extends PureComponent<IConfigYoutubeMcpInputProps, IConfigYoutubeMcpInputState> {
  formInputName: string[] = ["apiConfig", "youtubeMcpSettingsId"];

  constructor(props: IConfigYoutubeMcpInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingYoutubeMcpId: ""
    };
  }

  openModal = (): void => {
    this.setState({ showModal: true, editingYoutubeMcpId: "" });
  };

  closeModal = (): void => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string): void => {
    this.setState({ editingYoutubeMcpId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render(): ReactNode {
    return (
      <>
        <ConfigYoutubeMcpSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingYoutubeMcpId={this.state.editingYoutubeMcpId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="YouTube"
          formInputName={this.formInputName}
          options={this.props.commonSettings.youtubeMcpSettings ?? []}
          allowClear
          tooltipContentKey="appsettings_mcp_youtubemcp"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsMcpYoutubeDropdown"
          addNewTestId="appSettingsMcpYoutubeAddNewButton"
          editTestId="appSettingsMcpYoutubeEditButton"
        />
      </>
    );
  }
}
